import { render, staticRenderFns } from "./WonderStrategyDetail.vue?vue&type=template&id=32723fde&scoped=true"
import script from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
export * from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderStrategyDetail.vue?vue&type=style&index=0&id=32723fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32723fde",
  null
  
)

export default component.exports